export enum SigmaTileLayers {
  PLAN = "Plan",
  IGN = "IGN",
  MARKET = "Market",
  ARCEP = "Arcep"
}
